import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { toastEmitter } from "../../utils/utilities";
import { deleteUser } from "../../hooks/services/api-services";
import { LOGO_ICON } from "../../utils/aap-image-constant";

const VerifyDelete = () => {
  const location = useLocation();

  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("PENDING");

  const [payload, setPayload] = useState({
    email: "",
    type: "",
  });

  //Read URL params (email + type)
  useEffect(() => {
    const params = new URLSearchParams(location.search);

    const email = params.get("email");
    const type = params.get("type");

    if (!email || !type) {
      toastEmitter("error", "Invalid verification link");
      setStatus("ERROR");
      return;
    }

    setPayload({ email, type });
  }, [location.search]);

  // Verify / Delete handler
  const handleVerify = async () => {
    if (!payload.email || !payload.type) {
      toastEmitter("error", "Invalid data");
      setStatus("ERROR");
      return;
    }

    try {
      setLoading(true);
      const res = await deleteUser(payload.email, payload.type);

      if (res?.data?.status === 200) {
        toastEmitter("success", res?.data?.message || "Account deleted successfully");
        setStatus("SUCCESS");
      } else {
        toastEmitter("error", res?.data?.message || "Failed to delete account");
        setStatus("ERROR");
        console.error("Deletion failed:", res);
        return;
      }

    } catch (err) {
      toastEmitter("error", err?.response?.data?.message || "Link expired or invalid");
      setStatus("ERROR");
    } finally {
      setLoading(false);
    }
  };

  /* SUCCESS UI */
  if (status === "SUCCESS") {
    return (
      <div className="container-fluid min-vh-100 d-flex justify-content-center align-items-center bg-light">

        <div className="card p-5 text-center shadow border-0">
          <div className="text-center mb-3">
            <img
              src={LOGO_ICON}
              alt=""
              className="logoimg"
            />
          </div>
          <h5 className="text-success">
            Account Deleted Successfully
          </h5>

          <p className="text-muted">
            Your account has been permanently deleted.
          </p>
        </div>
      </div>
    );
  }

  /* ERROR UI */
  if (status === "ERROR") {
    return (
      <div className="container-fluid min-vh-100 d-flex justify-content-center align-items-center bg-light">

        <div className="card p-5 text-center shadow border-0">
          <div className="text-center mb-3">
            <img
              src={LOGO_ICON}
              alt=""
              className="logoimg"
            />
          </div>
          <h5 className="text-danger">Verification Failed</h5>

          <p className="text-muted">
            Invalid or expired link.
          </p>
        </div>
      </div>
    );
  }

  /* DEFAULT UI */
  return (
    <div className="container-fluid min-vh-100 d-flex justify-content-center align-items-center bg-light">

      <div className="card p-5 text-center shadow border-0">
        <div className="text-center mb-3">
          <img
            src={LOGO_ICON}
            alt=""
            className="logoimg"
          />
        </div>
        <h5 className="mb-2">Confirm Account Deletion</h5>

        <p className="text-muted mb-3">
          Click below to confirm deleting your account.
        </p>

        <button
          className="btn btn-danger w-100"
          onClick={handleVerify}
          disabled={loading}
        >
          {loading ? "Processing..." : "Delete My Account"}
        </button>

        <p className="small mt-3">
          If you didn’t request this, ignore this email.
        </p>
      </div>
    </div>
  );
};

export default VerifyDelete;